<div class="udex-grid udex-mx-auto udex-py-56">
  <div class="block-container udex-mx-auto">
    @if (showErrors) {
      <dcp-disposable-message class="udex-mb-20"></dcp-disposable-message>
    }

    @if (!isRegularRegistrationFlow) {
      <ng-container [ngTemplateOutlet]="autoRegistrationFlow"></ng-container>
    } @else {
      @if (!companies) {
        <ng-container [ngTemplateOutlet]="loading"></ng-container>
      } @else {
        @if (selectedCompany) {
          <dcp-company-address-selection [(company)]="selectedCompany"></dcp-company-address-selection>
        } @else {
          <h3 class="heading__regular--xs udex-mb-20">
            {{'registration.headingSelectCompany' | cxTranslate}}
          </h3>
          <p class="body--m text-grey udex-mb-20">
            {{'registration.subheadingSelectCompany' | cxTranslate}}
          </p>
          <udex-select-box
            label="Company/Organization Name"
            class="d-block udex-mb-20"
            mode="SingleSelect"
            search-placeholder="Company/Organization Name"
            height="200px"
            [accessibleName]="'registration.searchPlaceholder' | cxTranslate"
            required
            (selection-change)="setCompany($event)">
            @for (company of companies; track $index) {
              <udex-select-box-item
                [label]="company.displayName"
                [attr.data-cy]="company.displayName"
                [attr.data-index]="$index">
              </udex-select-box-item>
            }
          </udex-select-box>

          <p data-cy="create-new" class="body--xs text-blue-gray udex-mb-20">
            {{'registration.newCompany.createNew1' | cxTranslate}}<br>
            {{'registration.newCompany.createNew2' | cxTranslate}}
            <udex-link
              class="body--xs"
              [routerLink]="'/b2b-registration'"
              data-cy="create-new-organization-link"
              design="Default">
              {{'registration.newCompany.createNew3' | cxTranslate}}
            </udex-link>
          </p>

          <udex-button
            size="Large"
            design="Secondary"
            (click)="goBack()">
            {{'common.back' | cxTranslate}}
          </udex-button>
        }
      }
    }
  </div>
</div>

<ng-template #autoRegistrationFlow>
  @if (!autoBpCreationError) {
    <ng-container [ngTemplateOutlet]="loading"></ng-container>
  } @else {
    <dcp-generic-configurator-error
      imgPath="../../../../assets/images/configurator/checkout_service_error.png"
      headline="configurator.error.somethingWrong">
    </dcp-generic-configurator-error>
    <p role="alert" class="text-center body--s text-grey udex-mb-20">
      @if (autoBpCreationError.description) {
        <span [attr.data-cy]="'auto-bp-errorMessage'" [innerHTML]="autoBpCreationError.description"></span>
      } @else {
        <p role="alert" data-cy="auto-bp-errorMessage">
          <span>{{'configurator.error.contactUs.message' | cxTranslate}}</span>
          <dcp-contact-us-link [isEnd]="false"></dcp-contact-us-link>
          <span>{{'configurator.error.contactUs.proceed' | cxTranslate}}</span>
        </p>
      }

      @if (autoBpCreationError.errorCode) {
        <span [attr.data-cy]="'auto-bp-errorCode'" class="text-nowrap">
          &nbsp; {{'configurator.error.code' | cxTranslate: {errorCode: autoBpCreationError.errorCode} }}
        </span>
      }
      @if (showContactUsButton) {
        <div class="d-flex justify-content-center">
          <dcp-contact-us-button [errorMessage]="autoBpCreationError?.description"></dcp-contact-us-button>
        </div>
      }
    </p>
  }
</ng-template>

<ng-template #loading>
  <dcp-loading-page [loadingText]="'registration.company.loading' | cxTranslate" [attr.data-cy]="'domain-tool-loading'"/>
</ng-template>
